/**
 * Status da conexão com a API do IBPT. Mesmos ids do catálogo db_motor_fiscal.ibpt_status_conexao.
 * "Testando" existe só na tela.
 */
export enum IbptStatusConexaoEnum {
    Conectada = 1,
    SemResposta = 2,
    CredenciaisRecusadas = 3,
}
